/**
 * API Slice (Redux Toolkit Query)
 * Provides base query setup for the restaurant website
 */

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { UnifiedContent } from "./slices/contentSlice";

// Base URL - currently pointing to public folder, easily changed to backend API
const BASE_URL = "/content";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    credentials: "include",
    prepareHeaders: (headers) => {
      return headers;
    },
  }),
  tagTypes: ["Content"],
  endpoints: (builder) => ({
    getUnifiedContent: builder.query<UnifiedContent, void>({
      query: () => "/content.json",
      providesTags: ["Content"],
    }),
  }),
  refetchOnFocus: false,
  refetchOnReconnect: true,
});

export const { useGetUnifiedContentQuery } = apiSlice;
